let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bFtIl")).then(() => parcelRequire('9HytV'));